<template>
  <div class>
    <chartsSVG class="charts-pos" :start="taskStart" :vertecies="vertexPoints" />
    <svg-chart
      :start="taskStart"
      :datasets="datasets"
      :vertecies="vertexPointsWave"
      :options="options"
      :svg="{ w: 260, h: 100 }"
      class="waves"
    ></svg-chart>
    <img :src="gameImg" class="game-img" alt="game back" />
    <div id="task-start" class="task-start pulse" @click="startAnimation(true)">STEP {{clickCount !== 0 ? clickCount : 1}}</div>
  </div>
</template>

<script>
import chartsSVG from "./LinesGraphSVG";
import svgChart from "./Waves";
import { gameImg } from "../configs/game";

export default {
  name: "game",
  props: {
    clickCount: { type: Number, default: null }
  },
  components: {
    chartsSVG,
    svgChart
  },
  data: () => ({
    gameImg,
    taskStart: false,
    vertexPoints: [[], []],
    vertexPointsWave: [[], []],
    options: {
      xMin: 0,
      xMax: 300,
      yMin: 0,
      yMax: 100,
      line: {
        smoothing: 0.2,
        flattening: 0.1
      }
    },
    datasets: [
      {
        name: "one",
        colors: {
          path: "#EEB012",
          circles: "transparent"
        }
      },
      {
        name: "two",
        colors: {
          path: "#1899E1",
          circles: "transparent"
        }
      }
    ]
  }),
  mounted: function() {
    setTimeout(() => {
      this.startAnimation(false);
    }, 1000);
  },
  methods: {
    generateRandomData() {
      const randomYGreen = [];
      const randomYBlue = [];

      for (let i = 1; i < 7; i++) {
        randomYGreen[i] = 10 + Math.floor(Math.random() * 120);
        randomYBlue[i] = 10 + Math.floor(Math.random() * 120);

        while (Math.abs(randomYGreen[i] - randomYBlue[i]) < 20) {
          randomYBlue[i] = 10 + Math.floor(Math.random() * 120);
        }
      }

      return [randomYGreen, randomYBlue];
    },
    startAnimation(clear) {
      this.vertexPoints = this.generateRandomData();
      this.vertexPointsWave = this.vertexPoints;

      this.taskStart = !this.taskStart;
      this.$emit("clickCounter");
    }
  }
};
</script>

<style scoped lang="scss">
.game-img {
  position: absolute;
  top: 85px;
  left: 22px;

  @media screen and (max-width: 1130px) {
    top: 64px;
    width: 85%;
    left: 20px;
  }

  @media screen and (max-width: 1012px) {
    top: 30px;
    width: 70%;
    left: 19px;
  }
}

.charts-pos {
  position: absolute;
  top: 148px;
  left: 13px;
  width: 88%;

  @media screen and (max-width: 1130px) {
    top: 126px;
  }

  @media screen and (max-width: 1012px) {
    left: 15px;
    width: 71%;
    top: 80px;
  }
}

.waves {
  position: absolute;
  bottom: 118px;
  width: 82%;
  left: 32px;

  @media screen and (max-width: 1130px) {
    bottom: 102px;
    left: 24px;
  }

  @media screen and (max-width: 1012px) {
    bottom: 192px !important;
    left: 26px;
    width: 66%;
  }
}

#task-start {
  position: absolute;
  width: 286px;
  height: 60px;
  background: #1899e1;
  border-radius: 40px;
  font-family: Roboto;
  font-style: normal;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  /* text-align: center; */
  text-transform: uppercase;
  color: #ffffff;
  justify-content: center;
  bottom: 49px;
  left: 24px;
   -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;

  @media screen and (min-width: 769px) {
    &:hover {
      background: #26b1ff;
      box-shadow: 0px 0px 15px #26b1ff;
    }

    &:active {
      background: #1187ca;
      box-shadow: none !important;
    }

    &:focus {
      box-shadow: none !important;
    }
  }

  @media screen and (max-width: 1130px) {
    height: 49px;
    width: 82%;
    bottom: 47px;
    left: 24px;
  }

  @media screen and (max-width: 1012px) {
    width: 186px;
    height: 45px;
    font-size: 14px;
    bottom: 160px;
    left: 22px;
  }
}
</style>
